<template>
  <td>
    <img v-if="icon()" :src="icon()" alt="" height="50" width="50" />
  </td>
</template>

<script>
import {  getVehiclesSideView } from "@/utils/icons";
// import redBus from "@/assets/icons/vehicles/bus-3d/red.svg";
export default {
  props: {
    dataItem: Object,
  },
  methods: {
    icon() {
      try {
        console.log("dataItem",this.dataItem)
        const vehicleType = this.$store.getters["getVehicleTypes"].find(
          (vcl) => vcl.id === this.dataItem.vehicleTypeId
        );
        let vehicleName = vehicleType ? vehicleType.type : this.dataItem.vehicleTypeId ?  this.dataItem.vehicleTypeId : '';
        return getVehiclesSideView(vehicleName);
      } catch (error) {
        console.log('Something went wrong:  ', error);
      }

    },
  },
};
</script>

<style scoped>
</style>